import { styled } from '@linaria/react'

export const arrowStyles = {
  position: 'absolute',
  top: 0,
  right: 0,
  margin: '14px',
  width: '30px',
  height: '30px',
  backgroundColor: '#fff',
  borderRadius: '100px',
  boxShadow: '1px 1px 2px rgba(0, 0, 0, 0.2)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}

export const Button = styled.button`
  ${arrowStyles}
`
export const StyledLink = styled.span`
  ${arrowStyles}
`

export const ImageSpacer = styled.div`
  padding: 0 4.5px;
`

export const ImageContainer = styled.div`
  position: relative;
  padding: 4px;
  flex: 1;
  border-radius: 25px;
  background-color: #fff;
  display: flex;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 25px;
  }
`
